<div class="stories" *ngIf="profile && stories.length">

  <img
    class="stories__canvas"
    src="{{assetsPath}}/images/canvas/576-1024-canvas.png"
    height="100%"
    [style]="{ 'background-image': 'url(' + (slides.length ? (slides[0].story.getCover()) : '') + ')' }"
  >

  <div class="stories__posts">

    <!-- STORIES TIMELINE -->
    <div class="bars">
      <div
        class="bars__line"
        *ngFor="let slide of slides"
        [class.bars__line--finished]="slide.hasFinished"
      >
        <div
          class="bars__progress"
          [style.width]="(slide.isActive ? ((slide.story.currentTime / slide.story.duration) * 100 | number:'1.0-0') : 0) + '%'"
        ></div>
      </div>
    </div>

    <!-- STORIES PROFILE -->
    <div class="header">

      <div class="header__profile">
        <mip-avatar class="header__avatar" [userModel]="profile"></mip-avatar>
        <strong class="header__username">{{ profile.getName() || '@' + profile.username }}</strong>
        <small class="header__time-ago" *ngIf="currentSlide">{{ currentSlide.story.createdAt | amTimeAgo : true }}</small>
      </div>

      <button
        class="header__close-btn"
        mat-icon-button
        matRipple matRippleColor="rgba(255, 255, 255, 0.2)"
        [routerLink]="this.getGoBackUrl"
      >
        <mip-icon icon="times"></mip-icon>
      </button>

    </div>

    <!-- STORIES SLIDES -->
    <div class="slides">

      <!-- SWIPER-CONTAINER -->
      <swiper
        #swiperContainer
        class="slides__container"
        [config]="swiperConfig"
        (slideChange)="slideChange($event)"
      >
        <!-- SWIPER-SLIDE -->
        <ng-template
          class="slides__item"
          *ngFor="let slide of slides; let $index = index"
          swiperSlide
        >
          <p style="position: absolute; bottom: 0; left: 0; background: #000; padding: 5px; z-index: 10;"> isAttached: {{ isActive }} {{ slide.isAttached }} {{ slide.isIntoViewport }} </p>

          <!-- POST-VIEW -->
          <mip-post-view
            class="slides__post"
            videoControlsPosition="bottom"
            *ngIf="slide.isAttached"
            [postModel]="slide.story"
            [enableDetailsLink]="false"
            [isIntoViewport]="slide.isIntoViewport && isActive"
            [isIntoTopBounceLimit]="slide.isIntoViewport && isActive"
            [isAdEnable]="false"
            [showInteraction]="false"
            [showHeader]="false"
            (onVideoEnded)="slideNext(slide)"
          ></mip-post-view>

        </ng-template>

      </swiper>

      <!-- SLIDES ACTIONS -->
      <div
        class="slides__action slides__action--prev"
        (click)="slidePrev()"
      ></div>
      <div
        class="slides__action slides__action--next"
        (click)="slideNext(currentSlide)"
      ></div>

    </div>

  </div>

</div>
